// src/fsd/shared/lib/validation/validateEmail.ts
export const validateEmail = (email: string): string => {
  if (!email) {
    return 'Email обязателен.';
  }
  if (!/\S+@\S+\.\S+/.test(email)) {
    return 'Ошибка в email.';
  }
  return '';
};
